import { render, staticRenderFns } from "./SectorTypeCreateOrUpdate.vue?vue&type=template&id=038bc22c&"
import script from "./SectorTypeCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SectorTypeCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports